import PrimaryButton from "../Shared/PrimaryButton";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";

const ColumnHeader = ({ title, subtitle, buttons = [], menuItems = [], belowHeader }) => {
  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-y-3">
        <div className="flex-auto min-w-0">
          <h3 className="text-lg/7 font-semibold text-ink-900">{title}</h3>
          {subtitle && (
            <p className="mt-1 text-sm text-ink-500">{subtitle}</p>
          )}
        </div>
        <div className="flex-shrink-0 flex items-center gap-2">
          {buttons.length > 0 && (
            <>
              {buttons.map(({ caption, onClick, color, icon: Icon }, index) => (
                <PrimaryButton key={index} onClick={onClick} colour={color} className={Icon ? "inline-flex items-center" : ""}>
                  {Icon && <Icon aria-hidden="true" className="-ml-0.5 mr-1.5 size-5" />}
                  {caption}
                </PrimaryButton>
              ))}
            </>
          )}
          {menuItems.length > 0 && (
            <Menu as="div" className="relative">
              <MenuButton className="-m-2 flex items-center rounded-full p-2 text-ink-500 hover:text-ink-600">
                <span className="sr-only">Open options</span>
                <EllipsisVerticalIcon className="size-5" aria-hidden="true" />
              </MenuButton>
              <MenuItems
                anchor="bottom end"
                transition
                className="z-10 w-36 rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <div className="py-1">
                  {menuItems.map(({ caption, onClick }, index) => (
                    <MenuItem key={index}>
                      {({ close }) => (
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            onClick();
                            close();
                          }}
                          className="block px-4 py-2 text-sm text-ink-700 data-[focus]:bg-cream-200 data-[focus]:text-ink-900 data-[focus]:outline-none"
                        >
                          {caption}
                        </a>
                      )}
                    </MenuItem>
                  ))}
                </div>
              </MenuItems>
            </Menu>
          )}
        </div>
      </div>
      {belowHeader ? (
        <>
          <div className="mt-4 border-l-4 border-accent-400 bg-accent-100/50 rounded-r-lg py-1 pl-3">
            <p className="text-xs font-medium text-accent-600 mb-1">Next Appointment</p>
            {belowHeader}
          </div>
          <div className="border-t border-ink-100" />
        </>
      ) : (
        <div className="mt-6 border-t border-ink-100" />
      )}
    </>
  );
};

export default ColumnHeader;
